// Henüz uygulanmayan widget tipleri (gömülü Dashboard — Faz 5, DevExpress) için açık yer tutucu.
import { Construction } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/shared/ui/EmptyState';

export function PlaceholderWidget({ type }: { type: string }) {
  const { t } = useTranslation();
  return <EmptyState icon={<Construction className="h-6 w-6" />} title={t('home.widgetSoon', { type })} />;
}
